const PAYLOAD_CODEC_SALT = "qw-payload-codec";
const textEncoder = typeof TextEncoder === "function" ? new TextEncoder() : null;
const textDecoder = typeof TextDecoder === "function" ? new TextDecoder() : null;

export function encodePayload(payload, key, namespace = "default") {
	let payloadString = JSON.stringify(payload);
	let derivedKey = buildDerivedKey(key, namespace);
	return bytesToBase64(
		xorBytes(utf8Encode(payloadString), utf8Encode(derivedKey))
	);
}

export function decodePayload(encodedValue, key, namespace = "default") {
	let derivedKey = buildDerivedKey(key, namespace);

	try{
		let payloadBytes = xorBytes(base64ToBytes(encodedValue), utf8Encode(derivedKey));
		return JSON.parse(utf8Decode(payloadBytes));
	}catch(error){
		let decodedString = window.atob(encodedValue);
		let payloadString = xorStringLegacy(decodedString, derivedKey);
		return JSON.parse(payloadString);
	}
}

function buildDerivedKey(key, namespace) {
	return `${PAYLOAD_CODEC_SALT}:${namespace}:${key || ""}`;
}

function utf8Encode(value) {
	if (textEncoder) {
		return textEncoder.encode(String(value || ""));
	}

	return Uint8Array.from(unescape(encodeURIComponent(String(value || ""))), (char) => char.charCodeAt(0));
}

function utf8Decode(bytes) {
	if (textDecoder) {
		return textDecoder.decode(bytes);
	}

	let binary = "";
	for (let index = 0; index < bytes.length; index += 1) {
		binary += String.fromCharCode(bytes[index]);
	}

	return decodeURIComponent(escape(binary));
}

function xorBytes(valueBytes, keyBytes) {
	let result = new Uint8Array(valueBytes.length);

	for (let index = 0; index < valueBytes.length; index += 1) {
		result[index] = valueBytes[index] ^ keyBytes[index % keyBytes.length];
	}

	return result;
}

function bytesToBase64(bytes) {
	let binary = "";
	let chunkSize = 32768;

	for (let index = 0; index < bytes.length; index += chunkSize) {
		binary += String.fromCharCode.apply(null, bytes.subarray(index, index + chunkSize));
	}

	return window.btoa(binary);
}

function base64ToBytes(value) {
	let binary = window.atob(value);
	return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

function xorStringLegacy(value, key) {
	let result = "";

	for (let index = 0; index < value.length; index += 1) {
		let valueCode = value.charCodeAt(index);
		let keyCode = key.charCodeAt(index % key.length);
		result += String.fromCharCode(valueCode ^ keyCode);
	}

	return result;
}
